import { createCRUDHook } from './createCRUDHook';
import { StoreSectionQuestionDto } from 'utils/models';
import { CREATE_BULK_ENTITY, ECG_STORE_SECTION_QUESTION } from './apiEndPoints';
interface StoreSectionQuestionCustomOperations {
  addBulkStoreSectionQuestion: (
    param: StoreSectionQuestionDto[]
  ) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  StoreSectionQuestionDto,
  StoreSectionQuestionDto[],
  StoreSectionQuestionCustomOperations
>({
  entityName: 'StoreSectionQuestion',
  endpoint: ECG_STORE_SECTION_QUESTION,

  customOperations: (auth) => ({
    addBulkStoreSectionQuestion: async (
      param: StoreSectionQuestionDto[]
    ): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedPost(
          ECG_STORE_SECTION_QUESTION + CREATE_BULK_ENTITY,
          param
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const StoreSectionQuestionContext = Context;
export const useStoreSectionQuestionManager = useManager;
export const useStoreSectionQuestion = useConsumer;
